// Game Boy / Game Boy Color are ONE system for every game.
//
// GBC titles play under the `gb` system in the client (there is no separate
// `gbc` system there), but in the catalog a ROM — and its achievement
// definitions — may be filed under either `gb` OR `gbc`. So any game-identity
// lookup keyed on system_id (game_id resolution, suggestions, titles, cheevos
// definitions) MUST treat the pair as interchangeable. Otherwise a fully-
// catalogued GBC game (e.g. "Link's Awakening DX", filed under gbc) reads as
// "not in the library" / has no achievements when played under gb.
//
// Shared by the server (src/server/system-merge.js re-exports this) and the
// client (achievement definition loader). Mirrors EXTRA_ROM_DIRS in server.js
// (which merges the gbc/ directory into gb for /api/roms file scanning).
// Add future console merges as additional groups here.
// Exported: server-side SQL that must respect merged identity (e.g. the
// favorites→roms join) derives family-scoped clauses from this single
// source instead of hard-coding the pair.
export const MERGE_GROUPS = [['gb', 'gbc']];

/**
 * Expand a system id to every system it is merged with (itself included).
 * mergedSystems('gb') → ['gb', 'gbc']; mergedSystems('nes') → ['nes'].
 */
export function mergedSystems(system) {
  const group = MERGE_GROUPS.find((g) => g.includes(system));
  return group ? group.slice() : [system];
}
